import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import "../MembershipPage.css";
import { withRouter } from "react-router-dom";
import { hgStripe } from "../StripeConfig.js";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";
import MembershipPlanCard from "./MembershipPlanCard";
import MembershipFAQ from "./MembershipFAQ";
import HgSuperPayAddonSection from "./HgSuperPayAddonSection";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import StarIcon from "@material-ui/icons/Star";

const styles = theme => ({
    card: {
      maxWidth: 400,
    },
    media: {
      height: 0,
      paddingTop: '56.25%',
    },
    actions: {
      display: 'flex',
    },
    expand: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      marginLeft: 'auto',
      [theme.breakpoints.up('sm')]: {
        marginRight: -8,
      },
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    button: {
        margin: theme.spacing.unit,
      },
  });

@inject("userStore", "hgBillingStore", "profileStore", "authStore", "organisationStore")
@withRouter
@observer
class AgentBilling extends Component{
    constructor(props){
        super(props);
    };

    state = {
        toggleModal: false
    };

    selectPlan = (value, type, isReturn) => {
        if(isReturn) return;
        this.props.selectPlan(value, type);
    }

    selecFreePlan = () => {
        this.props.selecFreePlan();
    }

    handleOpenModal = (isReturn) => {
        if(isReturn) return;
        this.setState({ toggleModal: true });
    }

    handleCloseModal = () => {
        this.setState({
            ...this.state,
            toggleModal: false
        });
    };

    render(){
        const { billingAccess } = this.props.hgBillingStore;
        
        var isAgentFree = !billingAccess ? true : false || billingAccess?.isFreePlan;
        var priceIdExisted = billingAccess?.priceId ? true : false;
        var isEssential = billingAccess?.isBasicPlan && !priceIdExisted;
        var isProPlan = billingAccess?.isProPlan && !priceIdExisted;
        var isAgentEssentialMonthly = billingAccess?.priceId === hgStripe.pricing.agentMembershipMonthly;
        var isAgentEssentialPerGigs = billingAccess?.priceId === hgStripe.pricing.agentMembershipPayAsYouGo;
        var isAgentProMonthly = billingAccess?.priceId === hgStripe.pricing.agentMembershipProMonthly;
        var isAgentProPerGigs = billingAccess?.priceId === hgStripe.pricing.agentMembershipProMonthlyPayAsYouGo;

        const freeFeatures = [
            "Unlimited venues",
            "Up to 8 bookings per month",
            "Unlimited consultants",
            "Integrated worksheet & contracts",
            "Venue roster & calendar management",
            "Act roster management including venue favourites",
            "Cancellation workflows",
            "Automated venue and artist invoicing"
        ];

        const essentialsFeatures = [
            "Unlimited bookings",
            "Unlimited consultants",
            "Automated gig promotion",
            "Social post management for both live events and general social posts"
        ];

        const proFeatures = [
            "Manage social posts to venue social channels",
            "Accounting Package Integrations including XERO & MYOB (Quickbooks coming soon)"
        ];

        return (
           <Fragment>
                <div className="membership-container">
                    <Grid container>
                        <Grid item xs={12}>
                            <div className="membership-grid">
                                <MembershipPlanCard
                                    planType="free"
                                    planName="Free"
                                    tagline="Get started with the basics"
                                    icon={<PersonOutlineIcon style={{ fontSize: 24 }} />}
                                    features={freeFeatures}
                                    isFreePlan={true}
                                    isCurrentPayg={isAgentFree}
                                    isCurrentMonthly={isAgentFree}
                                    onSelectFree={() => this.handleOpenModal(isAgentFree)}
                                />

                                <MembershipPlanCard
                                    planType="essentials"
                                    planName="Essentials"
                                    tagline="Everything in Free plus:"
                                    icon={<TrendingUpIcon style={{ fontSize: 24 }} />}
                                    features={essentialsFeatures}
                                    paygPrice="$15"
                                    monthlyPrice={!isAgentEssentialMonthly && isEssential ? "Free" : "$159"}
                                    isCurrentPayg={isAgentEssentialPerGigs}
                                    isCurrentMonthly={isAgentEssentialMonthly || (!isAgentEssentialMonthly && isEssential)}
                                    onSelectPayg={() => this.selectPlan(hgStripe.pricing.agentMembershipPayAsYouGo, 0, isAgentEssentialPerGigs)}
                                    onSelectMonthly={() => this.selectPlan(hgStripe.pricing.agentMembershipMonthly, 1, isAgentEssentialMonthly)}
                                />

                                <MembershipPlanCard
                                    planType="pro"
                                    planName="Pro"
                                    tagline="Everything in Essentials plus:"
                                    icon={<StarIcon style={{ fontSize: 24 }} />}
                                    features={proFeatures}
                                    paygPrice="$19"
                                    monthlyPrice={!isAgentProMonthly && isProPlan ? "Free" : "$199"}
                                    isCurrentPayg={isAgentProPerGigs}
                                    isCurrentMonthly={isAgentProMonthly || (!isAgentProMonthly && isProPlan)}
                                    onSelectPayg={() => this.selectPlan(hgStripe.pricing.agentMembershipProMonthlyPayAsYouGo, 0, isAgentProPerGigs)}
                                    onSelectMonthly={() => this.selectPlan(hgStripe.pricing.agentMembershipProMonthly, 1, isAgentProMonthly)}
                                    highlighted={true}
                                />
                            </div>

                            <HgSuperPayAddonSection />
                            <MembershipFAQ />
                        </Grid>
                    </Grid>
                </div>

                <ConfirmationModal
                    open={this.state.toggleModal}
                    title={"Select Free Plan"}
                    message={`Are you sure you want to select the free plan?`}
                    closeHandler={this.handleOpenModal}
                    confirmationHandler={this.selecFreePlan}
                    declineHandler={this.handleCloseModal}
                    confirmationLabel="Confirm"
                />
           </Fragment>
        );
    }
}

export default withStyles(styles)(AgentBilling);
